import { render } from "./WhiteDots.vue?vue&type=template&id=8b47f1c6&scoped=true"
import script from "./WhiteDots.vue?vue&type=script&lang=js"
export * from "./WhiteDots.vue?vue&type=script&lang=js"

import "./WhiteDots.vue?vue&type=style&index=0&id=8b47f1c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b47f1c6"]])

export default __exports__